import { loadStyle } from 'globalutils/fmUtils';
import PropTypes from 'prop-types';
import React, { lazy } from 'react';
import Form from './Form';
import ParentStyled from './style';

const Styled = loadStyle(ParentStyled, 'modules/UserManagement');
const Breadcrumb = lazy(() => import(`globalcomponents/Breadcrumb`));

const Index = ({ theme, filters, ...contentProps }) => {
  return (
    <>
      <Breadcrumb filters={filters} />
      <Component {...contentProps} Styled={Styled} />
    </>
  );
};
export default Index;

const Component = (props) => {
  return (
    <Styled.Wrapper>
      <div className="spireonNewonly topSection"></div>
      <Form {...props} />
    </Styled.Wrapper>
  );
};

Component.propTypes = {
  history: PropTypes.object.isRequired,
};
